import { ModalManager } from "@circle-react/components/Layout/ModalManagerProvider";
import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { postInvalidations } from "@circle-react/lib/queries/posts";
import { useMutation } from "react-query";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";
import { WorkflowsMomentumModal } from "@/react/components/WorkflowsMomentumModal";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";

const POST_FLAGGED_CONTENTABLE_TYPE = "Post";

export interface ReportPostFormValues {
  reported_reason_body: string;
  reported_reason_type: string;
}

interface UseReportPostMutationParams {
  onSuccess: () => void;
  postId: number;
}

export const useReportPostMutation = ({
  postId,
  onSuccess,
}: UseReportPostMutationParams) => {
  const toast = useToast();
  const { currentCommunityMember } = usePunditUserContext();

  return useMutation({
    mutationFn: (formData: ReportPostFormValues) =>
      reactQueryPost(internalApi.flaggedContent.create(), {
        flagged_content: {
          ...formData,
          flagged_contentable_id: postId,
          flagged_contentable_type: POST_FLAGGED_CONTENTABLE_TYPE,
        },
      }),
    onSuccess: () => {
      void postInvalidations.allPosts();
      void postInvalidations.postDetails(postId);

      toast.success(t("report_post_success"));

      if (isCommunityAdmin(currentCommunityMember)) {
        void ModalManager.show(WorkflowsMomentumModal, {
          templateKey: "ai_moderate_new_posts",
        });
      }

      onSuccess();
    },
    onError: () => {
      toast.error(t("something_went_wrong"));
    },
  });
};
